"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartValidationService = void 0;
var joi_1 = __importDefault(require("joi"));
var Result_1 = require("../../../../../models/concrete/Result");
var CartValidationService = /** @class */ (function () {
    function CartValidationService() {
        this.schemaForGetCartItems = joi_1.default.object().keys({});
        this.schemaForAddItemToCart = joi_1.default.object().keys({
            productId: joi_1.default.number().required(),
            modificationId: joi_1.default.number().optional(),
            quantity: joi_1.default.number().required(),
            data: joi_1.default.any().optional()
        });
        this.schemaForRemoveItemFromCart = joi_1.default.object().keys({
            cartItemId: joi_1.default.string().required()
        });
        this.schemaForClearCart = joi_1.default.object().keys({});
        this.schemaForUpdateCartItem = joi_1.default.object().keys({
            cartItemId: joi_1.default.string().required(),
            modificationId: joi_1.default.number().optional(),
            quantity: joi_1.default.number().required(),
            data: joi_1.default.string().optional()
        });
    }
    CartValidationService.prototype.getCartItemsData = function (data) {
        var error = this.schemaForGetCartItems.validate(data).error;
        // debug
        console.debug('Validating get cart items data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    CartValidationService.prototype.addItemToCartData = function (data) {
        var error = this.schemaForAddItemToCart.validate(data).error;
        // debug
        console.debug('Validating add item to cart data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    CartValidationService.prototype.removeItemFromCart = function (data) {
        var error = this.schemaForRemoveItemFromCart.validate(data).error;
        // debug
        console.debug('Validating remove item from cart data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    CartValidationService.prototype.clearCartData = function (data) {
        var error = this.schemaForClearCart.validate(data).error;
        // debug
        console.debug('Validating clear cart data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    CartValidationService.prototype.updateCartItemData = function (data) {
        var error = this.schemaForUpdateCartItem.validate(data).error;
        // debug
        console.debug('Validating update cart data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    return CartValidationService;
}());
exports.CartValidationService = CartValidationService;
//# sourceMappingURL=CartValidationService.js.map